import React from 'react';
import { Badge, Button, Icon } from '../basic';

export type UpdateToastProps = {
  count: number;
  message: string;
  actionLabel: string;
  onAction: () => void;
};

export function UpdateToast({
  count,
  message,
  actionLabel,
  onAction,
  ...props
}: Readonly<UpdateToastProps>): React.JSX.Element {
  // Do not render anything if there are no pending changes to show
  if (count < 1) {
    return <></>;
  }
  return (
    <div
      {...props}
      className="ehs-update-toast"
      role="status"
      aria-live="polite"
      aria-atomic="true"
      data-testid="ehs-updateToast"
    >
      <div className="update-toast-icon-wrapper">
        <Icon iconName="dashboard" aria-label={undefined} />
        <Badge
          badgeType={'info'}
          label={count.toString()}
          className="update-toast-badge"
          data-testid="ehs-updateToast-badge"
        ></Badge>
      </div>
      <span className="update-toast-message">{message}</span>
      <Button
        variant="tertiary"
        text={actionLabel}
        onClick={onAction}
        data-testid="ehs-updateToast-action-button"
      />
    </div>
  );
}
